import request, { get, put } from './httpService';

const base = '/eyeexam';

export const EyeExamService = {
  listWithLimit(from, to, filters, sortBy, customerId, signal) {
    return get({
      url: `${base}/withlimit/${from}/${to}`,
      params: { 
        filters: filters, //Array.isArray(filters) ? JSON.stringify(filters) : (filters || ''),
        sortBy: sortBy, //Array.isArray(sortBy) ? JSON.stringify(sortBy) : (sortBy || []),
        customerId 
      },
      signal
    }).then(res => res.data);
  },
  listByCustomer(customerId, signal) {
    return get({ url: `${base}/customer/${customerId}`, signal }).then(res => res.data);
  },
  getById(id, signal) {
    return get({ url: `${base}/${id}`, signal }).then(res => res.data);
  },
  create(record) {
    return request({ method: 'POST', url: `${base}/new`, data: record }).then(res => res.data);
  },
  update(id, record) {
    return put({ url: `${base}/${id}`, data: record }).then(res => res.data);
  },
  void(id) {
    return request({ method: 'POST', url: `${base}/${id}/void` }).then(res => res.data);
  },
  delete(id) {
    return request({ method: 'DELETE', url: `${base}/${id}` }).then(res => res.data);
  },
  printSummary(id, templateId = null) {
    return request({
      method: 'GET',
      url: `/print/eye-exam/${id}`,
      params: templateId ? { templateId } : undefined,
      responseType: 'blob'
    });
  },
  // locking
  lock(id, ownerId, ttlSeconds) {
    return request({ method: 'POST', url: `${base}/${id}/lock`, data: { ownerId, ttlSeconds } }).then(res => res.data);
  },
  renewLock(id, ownerId, token, ttlSeconds) {
    return request({ method: 'POST', url: `${base}/${id}/lock/renew`, data: { ownerId, token, ttlSeconds } }).then(res => res.data);
  },
  releaseLock(id, ownerId, token) {
    return request({ method: 'POST', url: `${base}/${id}/lock/release`, data: { ownerId, token } }).then(res => res.data);
  }
};
